import PermissionWrapper from 'components/PermissionWrapper';
import { Plus } from 'icons/indexed-icons/Plus';
import { IconTextBtn } from 'components/RibbonComponent';
import React from 'react';
import { UserScopes } from 'types';
import { PermissionScopeName } from 'types/user-management';

type Props = {
  handleServiceModal?: (value: boolean) => void;
};
const CreateServiceBtn = ({ handleServiceModal }: Props): JSX.Element => {
  return (
    <PermissionWrapper page={PermissionScopeName.MAINTENANCE_MANAGER} scope={UserScopes.Write}>
      <IconTextBtn
        onClick={() => handleServiceModal && handleServiceModal(true)}
        data-targetid="create-service"
        gap=".5rem"
      >
        <Plus />
        Create Service
      </IconTextBtn>
    </PermissionWrapper>
  );
};

export default CreateServiceBtn;
